import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import AddSalaryComponent from '../feedback-form/AddFeedback';
import { useDebounce } from 'usehooks-ts';
import { CommonSevice } from '../../../../services/common';
import {
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { searchQuery } from '../../../../constants/constants';
import { DebounceTimer, LoadingStatus } from '../../../../constants/common';
import TryAgain from '../../../molecules/ErrorState/error.component';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';
import { FormHeader } from '../../../OnBoarding/common/formHeader';
import ListView from '../../../../atoms/DataList/ListView';
import { permissionsObj } from '../../../OnBoarding/Organization/RolesAndPermissions/constants/roles-permissions.constants';
import { Button, IconButton } from '@mui/material';
import {
  InfoOutlined,
  SettingsBackupRestoreOutlined,
} from '@mui/icons-material';
import { getFeedbackTabs } from '../../feed-back-app/utils/util';
import { getFormattedValues } from '../../../../utils/formatter';
import { DateRangePro } from '../../../molecules/DateRange/DateRangePro';

const AllFeedback = (props) => {
  const { title, moduleId, name } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(-1);
  const [viewMode, setViewMode] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const [salaryComponentId, setSalaryComponentId] = useState({});
  const [searchParams] = useSearchParams();
  const { currentUserRoleId } = useSelector((state) => state.main);
  const searchInput = searchParams?.get(searchQuery);
  const debouncedVal = useDebounce(searchInput, DebounceTimer);
  const { feedbackPermission } = useSelector(
    (state) => state.modulePermissions
  );
  const tabs = getFeedbackTabs(feedbackPermission).filter((item) => item.show);

  const location = useLocation();
  const navigate = useNavigate();
  const paths = location.pathname.split('/');
  const currentPath = paths[paths.length - 1];

  useEffect(() => {
    const expectedPath = `/feedback/${currentPath}`;
    setShowForm(false);
    navigate(expectedPath, { replace: true });
  }, [currentPath, location.pathname]);

  useEffect(async () => {
    if (!showForm) {
      try {
        setLoading(LoadingStatus.Loading);
        const response = await new CommonSevice().getAllFeedback(
          currentUserRoleId,
          moduleId,
          name,
          searchInput,
          selectedDate[0]
            ? getFormattedValues('YYYY-MM-DD', selectedDate[0])
            : null,
          selectedDate[1]
            ? getFormattedValues('YYYY-MM-DD', selectedDate[1])
            : null
        );
        setData(response);
        setLoading(LoadingStatus.Success);
      } catch (err) {
        setLoading(LoadingStatus.Failure);
        // showToast(err?.response?.data?.message, ToastThemes.error);
        throw err?.response?.data?.message;
      }
    }
  }, [showForm, debouncedVal, currentUserRoleId, moduleId, selectedDate]);

  const onClickAddIcon = () => {
    setShowForm(true);
    setSalaryComponentId('');
    setViewMode(false);
  };

  const onDetailsClick = (id) => {
    setShowForm(true);
    setViewMode(true);
    setSalaryComponentId(id);
  };

  const rowData = data?.map((items) => {
    const { id, rating, optionId, fkCreatedBy, createdUtc, remarks } = items;
    return {
      rating,
      remarks: remarks || '',
      fkCreatedBy: fkCreatedBy?.displayName || '',
      createdAt: createdUtc ? getFormattedValues('YYYY-MM-DD', createdUtc) : '',
      action: !feedbackPermission?.[name]?.[permissionsObj.allowEdit] ? (
        { hide: true }
      ) : (
        <IconButton
          onClick={() => onDetailsClick(id)}
          disabled={!feedbackPermission?.[name]?.[permissionsObj.allowEdit]}
        >
          <InfoOutlined sx={{ color: 'primary.main80' }} />
        </IconButton>
      ),
      id: {
        hide: true,
        value: id,
      },
    };
  });

  const isDisabledReset = () => {
    if (selectedDate[0] === null && selectedDate[1] === null) {
      return true;
    }
    return false;
  };

  const resetFilters = () => {
    setSelectedDate([null, null]);
  };

  if (loading === LoadingStatus.Failure) {
    return <Navigate to={tabs?.length ? tabs[0].path : '/home'} />;
  } else {
    return (
      <>
        <CircularLoader show={loading === LoadingStatus.Loading} />
        {showForm ? (
          <AddSalaryComponent
            viewMode={viewMode}
            setViewMode={setViewMode}
            payCycleId={salaryComponentId}
            setShowForm={setShowForm}
            setPayCycleId={setSalaryComponentId}
          />
        ) : (
          <Box>
            <Box display="flex" justifyContent="space-between">
              <FormHeader title={title} />
              {/* <Box sx={{ background: 'white' }}> */}
              <Box
                display="flex"
                justifyContent="flex-end"
                gap={2}
                mb={1}
                p={2}
              >
                
                <DateRangePro
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
                <Button
                  startIcon={<SettingsBackupRestoreOutlined />}
                  sx={{ textTransform: 'capitalize' }}
                  disabled={isDisabledReset()}
                  onClick={resetFilters}
                >
                  Clear
                </Button>
              </Box>
            </Box>
            <ListView
              headCells={[
                { id: 'rating', label: 'Rating' },
                { id: 'remarks', label: 'Remarks' },
                { id: 'fkCreatedBy', label: 'Feedback Given By' },
                {
                  id: 'createdAt',
                  label: 'Submission Date',
                  dataType: 'date',
                  dateFormat: 'YYYY-MM-DD',
                },
              ]}
              rowsData={rowData || []}
              showSerialNo={true}
              showCheckbox={false}
              showAddIcon={
                false || feedbackPermission?.[name]?.[permissionsObj.allowAdd]
              }
              onAddClick={() => onClickAddIcon()}
            />
          </Box>
        )}
      </>
    );
  }
};

export default AllFeedback;
